import React, { useState, useEffect } from 'react';
import "./DomainPage.css";
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const EditDomainPage = () => {
  const { domainId } = useParams(); // Fetch domainId from params
  console.log("Domain ID:", domainId); 
  const [formData, setFormData] = useState({
    name: '',
    status: '',
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  // Fetch domain data for editing
  useEffect(() => {
    console.log("Domain ID:", domainId); 
    const fetchDomainData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/admin/domains/${domainId}`
        );
        console.log(`${process.env.REACT_APP_BASE_URL}api/admin/domains/${domainId}`);
        console.log("Fetched domain data:", response.data);
        const data = response.data;
        setFormData({
          name: data.name,
          status: data.status,
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching Domain data:', error);
        setError('Failed to fetch domain data.');
        setLoading(false);
      }
    };

    if (domainId) {
      fetchDomainData();
    }
  }, [domainId]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Validate domain name (regex for domain validation)
  const validateDomain = (domain) => {
    // This regex will allow only email-like domains, e.g., @gmail.com, @yahoo.com, etc.
    const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(domain);
  };

  // Form validation
  const validateForm = () => {
    const errors = {};
    if (!formData.name || !validateDomain(formData.name)) {
      errors.name = 'Please enter a valid domain name (e.g., @gmail.com)';
    }
    if (!formData.status) {
      errors.status = 'Status is required';
    }
    return errors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form data
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setValidationErrors(validationErrors);
      Swal.fire('Error', 'Please fill in all required fields', 'error');
      return;
    }
    setValidationErrors({}); 
    try {
      setLoading(true);
      const res = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/admin/domains/${domainId}`,
        formData, // Send updated data without image
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Domain updated successfully!',
      });
      navigate('/domains');
    } catch (error) {
      console.error('Error updating domain:', error);
      setError('Failed to update domain.');
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update domain. Please try again later.',
      });
    }
  };

  return (
    <DashboardLayout>

      <section className='MainDivSec'>

        <Headings headspan="Edit" hedtext=" Domain " />

        <div className="AdduserFormDiv">

        {error && <p className="error-message">{error}</p>}
        {loading ? (
            <p className="Loadingpara">Loading...</p>
        ) : (

          <Form onSubmit={handleSubmit}>

              <div className="FormGroupDiv">
                <label htmlFor="name">Domain Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter domain (e.g., @gmail.com)"
                  required
                />
              </div>

              <div className="FormGroupDiv">
                <label htmlFor="name">Status:</label>
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required >
                  <option value="">Select status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                  {validationErrors.status && (
                    <small className="error">{validationErrors.status}</small>
                  )}
              </div>

              <div className="SubMit">
                <button type="submit" disabled={loading}>
                  {loading ? 'Updating...' : 'Update Domain'}
                </button>
              </div>

                

          </Form>

         
        )}





        </div>

      </section>


      
    </DashboardLayout>
  );
};

export default EditDomainPage;
